import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { H6, Image, P } from "../../../AbstractElements";
import { ScrollableListTitle } from "../../../Constants/Constants";
import { ScrollableListData, ScrollableListSubTitle } from "../../../Data/UiKits/Lists";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const ScrollableList = () => {
  return (
    <Col xxl="4">
      <Card>
        <CommonCardHeader title={ScrollableListTitle} span={ScrollableListSubTitle} />
        <CardBody>
          <ListGroup className="pt-0 main-lists-content scrollbar-wrapper custom-scrollbar">
            {ScrollableListData &&
              ScrollableListData.map((item, index) => (
                <ListGroupItem action className={`list-hover-primary ${index === 0 ? " active" : ""}`} key={index}>
                  <div className="list-wrapper gap-0">
                    <Image className="list-img" src={dynamicImage(`user/${item.image}`)} alt="profile" />
                    <div className="list-content">
                      <H6>{item.head}</H6>
                      <P>{item.mail}</P>
                      <small className={index !== 0 ? "text-muted" : ""}>{item.small}</small>
                    </div>
                  </div>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ScrollableList;
